import { z } from "zod";
export const HostedReleaseLedgerEntryV1Schema = z
    .object({
    schemaVersion: z.literal("hosted-release-ledger-entry.v1.0"),
    releaseId: z.string().min(1),
    artifactRef: z.string().min(1),
    environmentLabel: z.string().min(1),
    domainLabel: z.string().min(1),
    actorLabel: z.string().min(1),
    recordedAt: z.string().datetime(),
    outcome: z.enum(["SUCCESS", "FAILED", "ROLLED_BACK"]),
})
    .strict();
export function appendHostedReleaseLedgerEntry(ledger, entry) {
    const duplicate = ledger.some((row) => row.releaseId === entry.releaseId);
    if (duplicate) {
        throw new Error("release_ledger_immutable_duplicate");
    }
    return [...ledger, HostedReleaseLedgerEntryV1Schema.parse(entry)];
}
//# sourceMappingURL=append-only-release-ledger.js.map